import React  from 'react';
import { Card } from './Card';
import './card.scss';

interface IExtendedCard {
  title: string;
  children: any;
  isEditable?: boolean;
  onClickHandler?: Function

}
export const ExtendedCard: React.FC<IExtendedCard> = ({ title, isEditable, children, onClickHandler }) => {
  const customCardStyles = {
    '--page-background-color': window?.tz_globalConfigs?.styling?.pageBackgroundColor || '#fff',
    '--widget-background-color': window?.tz_globalConfigs?.styling?.widgetBackgroundColor || '#fff',
  }  as React.CSSProperties;

  return (
    <div className="extended-card" style={customCardStyles}>
      <div className="extended-card-header">
        {title && <h2 className="extended-card-title">{title}</h2>}
        {isEditable && <div className="extended-card-edit-btn">Edit</div>}
      </div>
      <div onClick={onClickHandler ? () => onClickHandler() : undefined }>
        <Card>
          {children}
        </Card>
      </div>
    </div>
  );
};
